import { Component } from '@angular/core';

import { Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {
  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private translateService: TranslateService,
    private statusBar: StatusBar
  ) {
    this.translateService.addLangs(['es', 'en']);

    let langDef = 'en';
    // if (localStorage.getItem('idioma')) {
    //   langDef = localStorage.getItem('idioma');
    // } else {
    //   localStorage.setItem('idioma', langDef);
    // }
    localStorage.setItem('idioma', langDef);
    this.translateService.setDefaultLang(langDef);
    this.translateService.use(langDef);
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
    });
  }
}
